import { useRouter } from 'next/router'
import useUser, { isWorkspaceMember } from 'shared/hooks/use-user'
import { useGetCoursePageUrl } from 'modules/course/hooks/use-course-path-url'

interface UseThemeEditorToggleResult {
  closeEditor: () => Promise<boolean>
  openEditor: () => Promise<boolean>
  isOpenEditor: boolean
  allowedToEdit: boolean
}

export default function useThemeEditorToggle(): UseThemeEditorToggleResult {
  const { user, isOwner, loading: isLoadingUserData } = useUser()

  const { query, replace } = useRouter()

  const coursePath = useGetCoursePageUrl()

  const { themeEditor, ...restParams } = query

  const isOpen = themeEditor === 'open'

  const closeEditor = async (): Promise<boolean> =>
    replace({ query: { ...restParams } }, undefined, { shallow: true, scroll: false })

  const openEditor = async (): Promise<boolean> =>
    replace({ query: { ...restParams, themeEditor: 'open' } }, undefined, {
      shallow: true,
      scroll: false,
    })

  const allowedToEdit =
    isLoadingUserData || !!(user && (isOwner || isWorkspaceMember(user)) && coursePath)

  return { closeEditor, openEditor, isOpenEditor: isOpen, allowedToEdit }
}
